export default __webpack_public_path__ + "static/media/allahummaCalligraphy.0bc9498a.png";